module.exports = __webpack_public_path__ + "static/media/galerija_2019 (38).2ebf992a.jpg";